<template>
  <span class="dlm-logo">
    <img
      src="/svg/icon-primary.svg"
      class="dlm-badge"
      :style="{ height: `${height}px`, width: `${height}px` }"
      alt="Delarmente"
    />
    <span class="dlm-wordmark" :style="{ fontSize: `${height * 0.86}px`, color: textColor }">DELARMENTE</span>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 22,
    start: 'primary',
    end: undefined,
  },
)

const textColor = computed(() => getColor(props.start))
</script>

<style scoped>
.dlm-logo {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}
.dlm-badge {
  border-radius: 24%;
  flex: none;
}
.dlm-wordmark {
  font-family: 'Baloo 2', 'Trebuchet MS', sans-serif;
  font-weight: 800;
  letter-spacing: 0.05em;
  line-height: 1;
}
</style>
